import PropTypes from 'prop-types';
import React from 'react';
import { Button } from 'grab-ui';
import I18n from 'i18n-js';
import closeIcon from 'public/icons/close.svg';
import cx from 'classnames';
import styles from './styles.less';

const OverlayBody = ({
  children,
  showConfirm,
  disabledConfirm,
  onConfirmClick,
  confirmButtonText = '',
  showSecondaryCTA,
  disabledSecondaryCTA,
  onSecondaryCTA,
  secondaryCTAText = '',
  showHeader,
  showTitle,
  title,
  showFooter,
  footer,
  showClose,
  customHeaderIcon,
  onClose,
  classnames = {
    overlayContent: '',
    confirmButton: '',
    footer: '',
  },
}) => (
  <div className={styles.overlayBody}>
    {showHeader && (
      <div className={styles.header}>
        {showClose && (
          <a className={styles.closeButton} onClick={onClose}>
            <img src={closeIcon} alt="close" />
          </a>
        )}
        {customHeaderIcon && (
          <a className={styles.closeButton} onClick={onClose}>
            <img src={customHeaderIcon} alt="close" />
          </a>
        )}
        {showTitle && <div className={styles.title}>{title}</div>}
      </div>
    )}
    <div className={cx(styles.overlayContent, classnames.overlayContent)}>
      {children}
    </div>
    {(showConfirm || showFooter) && (
      <div className={cx(styles.footer, classnames.footer)}>
        {footer}
        {showConfirm && (
          <Button
            type="primary"
            onClick={onConfirmClick}
            className={cx(styles.confirmButton, classnames.confirmButton)}
            disabled={disabledConfirm}
          >
            {confirmButtonText || I18n.t('v2.commonButton.confirm')}
          </Button>
        )}
        {showSecondaryCTA && (
          <Button
            type="secondary"
            onClick={onSecondaryCTA}
            className={cx(styles.secondaryCTAButton)}
            disabled={disabledSecondaryCTA}
          >
            {secondaryCTAText || I18n.t('v2.commonButton.confirm')}
          </Button>
        )}
      </div>
    )}
  </div>
);

OverlayBody.propTypes = {
  children: PropTypes.node,
  footer: PropTypes.node,
  onClose: PropTypes.func,
  showClose: PropTypes.bool,
  customHeaderIcon: PropTypes.string,
  showConfirm: PropTypes.bool,
  disabledConfirm: PropTypes.bool,
  onConfirmClick: PropTypes.func,
  confirmButtonText: PropTypes.string,
  showSecondaryCTA: PropTypes.bool,
  disabledSecondaryCTA: PropTypes.bool,
  onSecondaryCTA: PropTypes.func,
  secondaryCTAText: PropTypes.string,
  showFooter: PropTypes.bool,
  showHeader: PropTypes.bool,
  showTitle: PropTypes.bool,
  title: PropTypes.string,
  classnames: PropTypes.shape({
    overlayContent: PropTypes.string,
  }),
};

OverlayBody.defaultProps = {
  children: undefined,
  footer: undefined,
  onClose: undefined,
  showClose: false,
  customHeaderIcon: '',
  showConfirm: false,
  disabledConfirm: false,
  onConfirmClick: undefined,
  confirmButtonText: '',
  showSecondaryCTA: false,
  disabledSecondaryCTA: false,
  onSecondaryCTA: undefined,
  secondaryCTAText: '',
  showFooter: false,
  showHeader: false,
  showTitle: false,
  title: '',
  classnames: {
    overlayContent: '',
  },
};

export default OverlayBody;
